// extracted by mini-css-extract-plugin
module.exports = {"ratings":"ratings--xjmxu","ratings__count":"ratings__count--xjmxu"};